export default "__VITE_ASSET__BwAwiUZ6__"